export class CalendarValidityReferenceModel {
    public calendarValidityCode: string;
    public calendarValidityName: string;
    public sortSequence: number;
    public statusCode: string;    
}
